import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Link } from 'react-router-dom'; // הוספנו את הקישור לראוטר
import useFadeUp from '../hooks/useFadeUp';
import screen1 from '../assets/Screenshot_20260322_104917.jpg';
import screen2 from '../assets/Screenshot_20260322_104927.jpg';
import screen3 from '../assets/Screenshot_20260322_104938.jpg';
import appLogo from '../assets/megedSplash.png';
import { IOSPortalButton } from './TripPortal';


const features = [
    { icon: '🗺️', title: 'מסלול יומי מלא', desc: 'כל יום בטיול מפורט עם שעות, אתרים ומלון ומיקומים ב-Google Maps - הכל בלחיצה אחת.' },
    { icon: '💸', title: 'מעקב הוצאות בזמן אמת', desc: 'עקוב אחרי כל הוצאה במטבע המקומי ובשקלים - בלי הפתעות.' },
    { icon: '🔐', title: 'כספת מסמכים', desc: 'כל המסמכים, כרטיסי הטיסה, אישורי הזמנה ופוליסת הביטוח במקום אחד.' },
    { icon: '☎️', title: 'אנשי קשר וטיפים יחודיים', desc: 'רשימת אנשי הקשר הרלוונטים, מספרי הטלפון של המלון, הנהג, המדריך ועוד.' },
];

const screens = [
    { src: screen1, label: 'מסלול ומלון' },
    { src: screen3, label: 'דף הבית' },
    { src: screen2, label: 'מעקב הוצאות' },

];

const APK_URL = 'https://drive.google.com/file/d/1bzIUF9NjjpB-j7ty9u_leJVqwlvEz3qm/view?usp=sharing';

function DownloadButton({ apkUrl, appLogo }) {
    const [showQR, setShowQR] = useState(false);
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const handleClick = () => {
        if (isMobile) {
            window.open(apkUrl, '_blank');
        } else {
            setShowQR(!showQR);
        }
    };

    return (
        <div className="mt-6">
            <button
                onClick={handleClick}
                className="inline-flex items-center gap-4 bg-brand-blue hover:bg-brand-blue-dark
                   text-white px-5 py-4 rounded-2xl transition-all duration-200
                   shadow-card hover:shadow-card-lg hover:-translate-y-0.5 group w-full md:w-auto"
            >
                <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center flex-shrink-0 overflow-hidden shadow-sm">
                    <img src={appLogo} alt="MegeDigital" className="w-12 h-12 object-contain" />
                </div>
                <div className="text-right flex-1">
                    <div className="font-body text-[11px] text-white/65 font-light mb-0.5">
                        {isMobile ? 'הורד עכשיו - חינם' : 'סרוק להורדה במובייל'}
                    </div>
                    <div className="font-body font-bold text-[17px] leading-none">Megedigital</div>
                    <div className="font-body text-[11px] text-white/65 font-light mt-1">
                        זמין ל־Android בלבד
                    </div>
                </div>
                <div className="bg-white/20 rounded-xl w-10 h-10 flex items-center justify-center
                        group-hover:bg-white/30 transition-colors duration-200 flex-shrink-0">
                    {isMobile ? (
                        <span className="text-lg">⬇</span>
                    ) : (
                        <span className="text-lg">📱</span>
                    )}
                </div>
            </button>

            {!isMobile && showQR && (
                <div className="mt-4 inline-flex flex-col items-center gap-3
                        bg-white rounded-2xl p-5 shadow-card border border-brand-blue/10">
                    <QRCodeSVG
                        value={apkUrl}
                        size={160}
                        fgColor="#2B4BAA"
                        bgColor="#ffffff"
                        level="H"
                    />
                    <p className="font-body text-xs text-gray-400 font-light text-center max-w-[160px]">
                        סרוק עם הטלפון להורדה ישירה
                    </p>
                </div>
            )}
        </div>
    );
}

export default function AppSection() {

    const headerRef = useFadeUp(0);
    const phonesRef = useFadeUp(100);
    const featRef = useFadeUp(200);

    return (
        <section id="app" className="py-24 px-6 bg-brand-beige-light overflow-hidden">
            <div className="max-w-6xl mx-auto">

                <div ref={headerRef} className="text-center mb-16">
                    <div className="flex justify-center mb-8">
                        <div className="relative">
                            <div className="w-32 h-32 rounded-[32px] shadow-card-lg overflow-hidden">
                                <img src={appLogo} alt="MegeDigital" className="w-full h-full object-cover" />
                            </div>
                            <div className="absolute -bottom-3 -left-3 bg-brand-blue text-white text-[11px] font-bold px-3 py-1 rounded-full shadow-card">
                                Android
                            </div>
                        </div>
                    </div>
                    <span className="inline-block bg-brand-blue-light text-brand-blue text-[11px] font-bold tracking-[2px] uppercase px-4 py-1.5 rounded-full mb-4">
                        האפליקציה שלנו
                    </span>
                    <h2 className="font-display font-bold text-[clamp(1.8rem,3vw,2.6rem)] leading-tight tracking-tight text-gray-900 mb-4">
                        הטיול שלך - בכף ידך
                    </h2>
                    <p className="font-body font-light text-gray-500 text-[1.05rem] max-w-lg mx-auto leading-relaxed">
                        כל לקוח של מגד שמיים מקבל גישה לאפליקציה הייחודית שלנו. מסלול, הוצאות, מסמכים וזמינות מלאה - הכל במקום אחד.
                    </p>
                </div>

                <div className="grid md:grid-cols-2 gap-16 items-center">

                    <div ref={phonesRef} className="flex justify-center items-end gap-2 relative">
                        {screens.map(({ src, label }, i) => (
                            <div key={label} className={`relative flex-shrink-0 transition-all duration-300 ${i === 1 ? 'w-[42%] md:w-[200px] z-20' : 'w-[29%] md:w-[160px] z-10 mb-4 md:mb-6'}`}>
                                <div className="bg-gray-900 rounded-[32px] p-2 shadow-card-lg">
                                    <div className="bg-gray-900 rounded-[28px] overflow-hidden">
                                        <div className="bg-gray-900 h-6 flex justify-center items-center">
                                            <div className="w-16 h-3 bg-gray-800 rounded-full" />
                                        </div>
                                        <img src={src} alt={label} className="w-full object-cover" />
                                    </div>
                                </div>
                                <div className="text-center mt-3">
                                    <span className="font-body text-xs text-gray-400 font-light">{label}</span>
                                </div>
                            </div>
                        ))}
                        <div className="absolute inset-0 bg-brand-blue/5 rounded-3xl blur-3xl -z-10" />
                    </div>

                    <div ref={featRef} className="flex flex-col gap-6">
                        {features.map(({ icon, title, desc }) => (
                            <div key={title} className="flex gap-4 items-start">
                                <div className="w-12 h-12 rounded-2xl bg-brand-blue flex items-center justify-center text-2xl flex-shrink-0 shadow-[0_4px_12px_rgba(43,75,170,0.25)]">
                                    {icon}
                                </div>
                                <div>
                                    <h4 className="font-body font-semibold text-[16px] text-gray-900 mb-1">{title}</h4>
                                    <p className="font-body font-light text-sm text-gray-500 leading-relaxed">{desc}</p>
                                </div>
                            </div>
                        ))}

                        <DownloadButton apkUrl={APK_URL} appLogo={appLogo} />

                        {/* iOS — כניסה לתיק הטיול */}
                        <Link to="/app" className="block w-full md:w-auto">
                            <IOSPortalButton />
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}
